import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from '@emotion/styled';
var RawHtml = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  letter-spacing: 0;\n\n  &,\n  p {\n    font-weight: 400;\n    font-family: 'Open Sans';\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: 'Montserrat';\n  }\n"])));
/**
 * This component is to be used to render html code from the backend.
 * Until now the html code from the backend doesnt match with our theme.
 * This component add a few styles from the typography styles directly in order to make it more compatible.
 * @param html
 * @returns
 */
export var StyledRawHtml = function StyledRawHtml(_ref) {
  var html = _ref.html;
  return html ? /*#__PURE__*/React.createElement(RawHtml, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  }) : null;
};